import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

export const DetailsLayout: React.FC<PropsWithChildren> = ({ children }) => {
  return <Box sx={{ display: 'flex', flexDirection: 'column' }}>{children}</Box>;
};
